<template>
  <div class="content keyword-wrap">
    
    <div :class="{'not-allowed': !$root.checkFeature('messages_keywords')}"
         class="d-block-create-msg ">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 col-sm-12 left-column">
            <h1 class="page-title ">
              <span>Keyword Text-In</span>
              <span class="del-text">Text-in number is <span class="phone-num">269-89</span></span>
            </h1>

            <!--a v-if="activeCharityInfo"
               :href="`${config.scheme}://${activeCharityInfo.subdomain}.${config.url}/wv2/keyword-landing`"
               target="_blank"
               class="preview-block">
              <img :src="require('./icons/bg_landingpage.png')" width="227px" height="193px" alt="">
              <div class="preview-block-caption">
                <span class="fw-600">Keyword Page</span><br><span
                  style="font-size: 10px;">Preview your Keyword Page</span>
              </div>
            </a-->

            <a class="preview-block"
               href="http://help.harnessapp.com/en/articles/3596221-harness-101-keyword"
               target="_blank"

            >
              <img :src="require('./icons/bg_messagechat.png')" width="227px" height="193px" alt="">
              <div class="preview-block-caption">
<!--                <div class="preview-block-counter">100</div>-->
                <span class="fw-600">Keyword FAQs</span><br><span
                  style="font-size: 10px;">Learn more about Keywords</span>
              </div>
            </a>

            <div class="row">
              <div class="col-sm-6">
                <h3><label for="keyword">Keyword</label></h3>
                <input type="text"
                       class="input-sm "
                       id="keyword"
                       style="text-transform: uppercase"
                       v-model="keyword"
                       :disabled="(!isLoaded || isEdit)"
                       @keyup="startCheck"
                       placeholder="KEYWORD">

              </div>
              <div class="col-sm-6">
                <h3><label>Availability</label></h3>

                <div class="keyword-status">This keyword is:</div>

                <div v-if="isChecking" class="keyword-status-val">Checking…</div>
                <div v-else-if="initialInfo && initialInfo.keyword.toUpperCase() === keyword.toUpperCase()"
                     class="keyword-status-val saved">Saved
                </div>
                <div v-else-if="keyword && isAvailable" class="keyword-status-val available">Available</div>
                <div v-else-if="keyword && !isAvailable" class="keyword-status-val not-available">Not Available</div>
              </div>
            </div>

            <div class="choose-text-message">
              <h3>Text Message</h3>

              <div class="upload-textarea-wrap upload-textarea-wrap-new-smg">

                <div class="dropdown-attach-to-msg dropdown-attach-to-msg-down">

                  <a class="btn btn-sm btn-sm-bold btn-attach dropbtn" data-dropdown=".select-actions" href="#"></a>

                  <add-attachment
                      :linksOnly="true"
                      :charity-info="activeCharityInfo"
                      v-on:select-attachment="selectAttachment"
                  ></add-attachment>

                </div>
                <textarea name="new-msg" id="new-msg" class="new-msg" placeholder="Type a message..."></textarea>
              </div>

            </div>

            <input type="hidden" class="attach-link">
            <div class="row">
              <div class="col-xs-6">
                <div class="">
                  <h3 class="attachment-title">Attachment</h3>
                  <attachment-edit v-if="attachmentInfo && attachmentInfo.type !== 'none'"
                                   :attachment-info="attachmentInfo"
                                   :charity-info="activeCharityInfo"
                                   v-on:remove-attachment="attachmentInfo = null"
                  ></attachment-edit>
                  <div v-else class="none-attachment">
                    <a class="dropbtn" data-dropdown=".select-actions" href="#">+ Attach a Link</a>
                  </div>
                </div>

              </div>
              <div class="col-xs-6">
                <div class="text-right btn-wrap">
                  <a href="#" class="btn btn-sm btn-cancel" v-on:click.prevent="$router.go(-1)">Cancel</a>
                  <a href="#"
                     v-on:click.prevent="saveKeyword()"
                     class="btn btn-sm">Save</a>
                </div>
              </div>
            </div>

          </div>
          <div class="col-md-6 col-sm-12 right-column">
            <div class="preview-msg clearfix">
              <div class="inner" v-if="activeCharityInfo">
                <div class="wrap">
                  <div class="ch-logo">
                    <img v-if="activeCharityInfo.logo_transparent"
                         :src="activeCharityInfo.logo_transparent"
                         :alt="activeCharityInfo.charity_name">
                  </div>
                  <div v-if="initialInfo" class="ch-name">Text {{initialInfo.keyword}} to 26989</div>
                  <div v-else class="ch-name">&nbsp;</div>
                </div>
                <div class="msg-text"><a v-if="attachmentInfo"
                                         :href="attachmentInfo.link"
                                         target="_blank"
                                         style="word-break: break-all;display: block"
                >{{attachmentInfo.link}}</a>{{newMessage}}<span v-if="!newMessage && !attachmentInfo"
                                                                class="placeholder">Preview of your message...</span>
                </div>

                <!--<div class="preview-img"></div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery';
  import MsgMenu from './menu.vue';
  import AddAttachment from './add-attachment.vue';
  import AttachmentEdit from './attachment-edit.vue';
  import Attachment from './attachment.vue';
  import config from '../../../public/harness_config.json';
  import {checkKeywordAvailability, deleteKeyword, registerKeyword, getCurrentKeyword} from '@/utils/api';
  import {getAttachmentBlock} from '@/utils/attachments';
  import {mapState} from "vuex";

  const debounce = require('debounce');

  export default {
    name: 'Keyword',
    metaInfo: {
      title: 'Keyword',
    },
    components: {
      MsgMenu,
      AddAttachment,
      AttachmentEdit,
      Attachment,
    },
    mounted() {
      this.isEdit = !!this.$route.params.keyword

      const self = this;

      $('#new-msg').emojioneArea({
        pickerPosition: 'right',
        filters: {
          symbols: {
            icon: 'heart',
          },
          flags: {
            icon: 'checkered_flag',
          },
        },
        events: {
          emojibtn_click: () => {
            $('.emojionearea').find('.emojionearea-button-close').click();
            self.onTxtChange();
          },
          change: () => self.onTxtChange(),
          keyup: () => self.onTxtChange(),
          paste: () => self.onTxtChange(),
        },
      });

      this.availabilityDebounce = debounce(this.checkAvailability, 750);
      this.upKeyword();
    },
    methods: {
      selectAttachment(attachment) {
        this.imageError = '';
        this.attachmentInfo = attachment;
      },
      onTxtChange() {
        this.newMessage = $('#new-msg').data('emojioneArea').getText();
      },
      upKeyword() {
        if (this.activeCharityInfo) {
          getCurrentKeyword(this.activeCharityInfo.charity_id).then(keywords => {
            let info = keywords.keywords.list.find((keyword)=> {
              return keyword.keyword === this.$route.params.keyword
            })
            this.isLoaded = true;
            if (info) {
              this.initialInfo = info;
              this.keyword = info.keyword;

              let msgText = info.message;

              let firstLine = msgText.split(/\r\n|\r|\n/)[0].trim();
              let attachmentInfo = getAttachmentBlock(firstLine, true);
              if ('type' in attachmentInfo && attachmentInfo.type !== 'none') {
                msgText = msgText.replace(firstLine, '').trim();
                this.attachmentInfo = attachmentInfo;
              }
              this.newMessage = msgText;

              $('#new-msg').data('emojioneArea').setText(msgText);
            }
          });
        }
      },
      startCheck() {
        this.isChecking = true;
        if (this.availabilityDebounce && this.keyword.length > 2 && this.keyword.length < 21) {
          this.availabilityDebounce();
        } else {
          this.isChecking = false;
          this.isAvailable = false;
        }
      },
      checkAvailability() {
        checkKeywordAvailability(this.keywordUppercase, this.activeCharityInfo.charity_id).then(res => {
          this.isChecking = false;
          this.isAvailable = res.text_in && res.text_in.available || false;
        });
      },
      register() {
        registerKeyword(this.keywordUppercase, this.textWithAttachment, this.activeCharityInfo.charity_id).then(info => {
          this.isLoaded = true;

          if (info.text_in) {
            this.$message('Your keyword has been saved');
            this.initialInfo = info.text_in;
            this.keyword = info.text_in.keyword;
            this.upKeyword();
            this.$router.push({name: 'keyword'})
          }
        }).catch(err => {
          this.isLoaded = true;
          alert(err.error || 'An error has occurred, please try again.');
        });
      },
      saveKeyword() {
        this.isLoaded = false;
        if (this.initialInfo) {
          //delete
          deleteKeyword(this.activeCharityInfo.charity_id).then(() => {
            this.register();
          }).catch(err => {
            this.isLoaded = true;
            alert(err.error || 'An error has occurred, please try again.');
          });
        } else {
          this.register();
        }
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      config() {
        return config;
      },
      keywordUppercase() {
        return this.keyword.toUpperCase();
      },
      textWithAttachment() {
        if (this.attachmentInfo) {
          return this.attachmentInfo.link + '\n' + this.newMessage;
        }
        return this.newMessage;
      },
      okSave() {
        //not loaded
        if (!this.isLoaded) {
          return false;
        }

        //not empty
        if (this.newMessage === '' || this.keyword === '') {
          return false;
        }

        //available and not checking
        if (this.isChecking || !this.isAvailable) {
          return false;
        }

        //existing and not updated
        if (this.initialInfo
          && this.initialInfo.keyword.toUpperCase() === this.keyword.toUpperCase()
          && this.initialInfo.message === this.textWithAttachment
        ) {
          return false;
        }

        return true;
      },
    },
    watch: {
      'activeCharityInfo'() {
        this.upKeyword();
      },
    },
    data() {
      return {
        keyword: '',
        attachmentInfo: null,
        newMessage: '',
        isChecking: false,
        isAvailable: true,
        isLoaded: false,
        isEdit: false,
        initialInfo: null,
        availabilityDebounce: null,
      };
    },
  };
</script>

<style lang="scss">


  .keyword-wrap {
    .emojionearea .emojionearea-button {
      right: 8px;
    }

    .phone-num {
      color: #0d70e3;
    }

    .keyword-status {
      font-size: 14px;
      color: rgba(53, 64, 82, 0.5);
      line-height: 19px;
    }

    .keyword-status-val {
      font-size: 14px;
      font-weight: 600;
      color: rgba(53, 64, 82, 0.8);
      line-height: 19px;

      &.available {
        color: #1da664;
      }

      &.not-available {
        color: #d35847;
      }

      &.saved {
        color: #0d70e3;
      }
    }
  }


  .preview-block {
    display: inline-block;
    position: relative;
    overflow: hidden;
    width: 188px;
    height: 119px;
    border-radius: 4px;
    background-color: #0d70e3;

    &:first-of-type {
      margin-right: 24px;
    }

    img {
      max-width: 100%;
      height: auto;
      position: absolute;
      right: 0;
      top: -19px;
    }

    span {
      font-size: 14px;
      opacity: 0.8;
      line-height: 1;
    }

    .preview-block-caption {
      color: #ffffff;
      position: absolute;
      bottom: 10px;
      left: 15px;

      .preview-block-counter {
        font-size: 30px;
        opacity: 0.9;
        margin-bottom: 3px;
      }
    }
  }
</style>
